import React, { Component } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";
import withFetchHook from "../withFetchHook";
import { FormInput } from "../tabs/PaymentsTab/onestep-library/BaseUI";
import { capitalize, intersection } from "lodash";
import classnames from "classnames";
import NoteShareWith from "./NoteShareWith";
import NoteSharedWith from "./NoteSharedWith";

class NoteComponent extends Component {
  state = {
    note: {},
    action: "show",
  };

  componentDidMount() {
    const {
      body,
      contacted_at,
      follow_up_at,
      risk_level,
      created_at,
      updated_at,
      id,
      author_id,
      author,
      note_tags,
    } = this.props.note;
    this.setState({
      note: {
        body: body,
        note_tags: note_tags,
        contacted_at: contacted_at ? moment(contacted_at) : null,
        follow_up_at: follow_up_at ? moment(follow_up_at) : null,
        risk_level:
          risk_level && risk_level.length > 0
            ? { label: capitalize(risk_level), value: risk_level }
            : null,
        created_at: created_at ? moment(created_at) : null,
        updated_at: updated_at ? moment(updated_at) : null,
        author: author,
        id: id,
        author_id,
      },
    });
  }

  handleChange(e) {
    this.setState({
      note: {
        ...this.state.note,
        body: e.target.value,
      },
    });
  }

  parseNoteFromApi(data, additionalInfo) {
    let parsedData = {
      ...data,
      author: this.props.note.author,
      author_id: this.props.note.author_id,
      risk_level:
        data.risk_level && data.risk_level.length > 0
          ? { label: capitalize(data.risk_level), value: data.risk_level }
          : null,
      ...additionalInfo,
    };
    return parsedData;
  }

  handleUpdate() {
    const { organizationName, residentId, note } = this.props;
    const { id, body, contacted_at, follow_up_at, risk_level, note_tags } = this.state.note;
    console.error('we are here???');
    console.error("note_tags", note_tags);

    this.props
      .fetch(
        `/organizations/${organizationName}/residents/${residentId}/notes/${note.id}.json`,
        {
          method: "PATCH",
          contentType: "application/json",
          data: JSON.stringify({
            note: {
              body: body,
              contacted_at: contacted_at
                ? contacted_at.format("YYYY-MM-DD ")
                : null,
              follow_up_at: follow_up_at
                ? follow_up_at.format("YYYY-MM-DD ")
                : null,
              risk_level: !!risk_level ? risk_level.value : null,
              note_tags_attributes: note_tags.map((tag) => {
                return {
                  recipient_id: tag.value ? tag.value : tag.recipient_id,
                  recipient_type: tag.recipient_type
                }
              })
            },
          }),
        }
      )
      .then((data) => {
        let newNote = this.parseNoteFromApi(data, { id: id });
        this.props.updateNote(newNote);
        this.setState({
          note: newNote,
          action: "show",
        });
      });
  }

  handleStarChange() {
    const { organizationName, residentId, note } = this.props;

    this.props
      .fetch(
        `/organizations/${organizationName}/residents/${residentId}/notes/${note.id
        }/${note.starred ? "unstar" : "star"}.json`,
        {
          method: "PATCH",
          data: {},
        }
      )
      .then((data) => {
        let newNote = this.parseNoteFromApi(data, { starred: !note.starred });
        this.props.updateNote(newNote);
        this.setState({
          note: newNote,
          action: "show",
        });
      });
  }

  handleRemove() {
    const { organizationName, residentId, note, deleteNote } = this.props;

    this.props
      .fetch(
        `/organizations/${organizationName}/residents/${residentId}/notes/${note.id}.json`,
        {
          method: "DELETE",
        }
      )
      .then(() => {
        deleteNote(note);
      });
  }

  renderContent() {
    const { action, note } = this.state;
    const { no_occupancies, current_user, permissions, isStaffApp } =
      this.props;

    if (action === "edit") {
      return (
        <div>
          <div className="col-12">
            <Form.Control
              as="textarea"
              value={note.body}
              onChange={this.handleChange.bind(this)}
              className="mb-xs-0 mb-lg-2 col-12"
            />
          </div>
          <div className={classnames({ "col-12": !isStaffApp, 'mb-2': !isStaffApp })}>
            <NoteShareWith
              groupTags={this.props.groupTags}
              userTags={this.props.userTags}
              values={this.state.note.note_tags}
              onChange={(updatedNoteTags) => this.setState({
                note: {
                  ...this.state.note,
                  note_tags: updatedNoteTags
                },
              })}
            />
          </div>
          {!this.props.resident["is_moved_in?"] && (
            <div className="d-flex">
              <div className="col-6">
                <FormInput
                  type="date"
                  label="Follow Up On"
                  value={this.state.note.follow_up_at}
                  handleChange={(follow_up_at) =>
                    this.setState({
                      note: { ...this.state.note, follow_up_at },
                    })
                  }
                  placeholder="Enter Follow Up On Date..."
                />
              </div>
              {!no_occupancies &&
                <div className="col-6">
                  <FormInput
                    type="date"
                    label="Contact Date"
                    value={this.state.note.contacted_at}
                    handleChange={(contacted_at) =>
                      this.setState({
                        note: { ...this.state.note, contacted_at },
                      })
                    }
                    placeholder="Enter Contact Date..."
                  />
                </div>
              }
              {!no_occupancies && (
                <div className="col-6">
                  <FormInput
                    label="Risk Level"
                    type="select"
                    placeholder="Select Risk Level.."
                    value={this.state.note.risk_level}
                    options={[
                      { label: "Low", value: "low" },
                      { label: "Medium", value: "medium" },
                      { label: "High", value: "high" },
                    ]}
                    handleChange={(risk_level) =>
                      this.setState({
                        note: { ...this.state.note, risk_level },
                      })
                    }
                  />
                </div>
              )}
            </div>
          )}
          <div className="d-flex justify-content-between col-12 pt-2">
            <div>
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => {
                  this.handleRemove();
                }}
              >
                Delete
              </Button>
            </div>
            <div>
              <Button
                size="sm"
                variant="outline-info"
                className="mr-2"
                onClick={() => this.setState({ action: "show" })}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                variant="info"
                className=""
                onClick={this.handleUpdate.bind(this)}
              >
                Update
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div
          dangerouslySetInnerHTML={{ __html: this.simpleFormat(note.body) }}
        />
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            {!!note.author && (
              <small className="text-secondary">
                Author: {note.author.name}
              </small>
            )}
            <small className="text-secondary">
              Created On: {moment(note.created_at).format("llll")}
            </small>
            {note && note.note_tags && <NoteSharedWith note_tags={note.note_tags}/>}
            {moment(note.created_at).format() !==
              moment(note.updated_at).format() && (
                <small className="text-secondary">
                  Updated On: {moment(note.updated_at).format("llll")}
                </small>
              )}
            {note.contacted_at && (
              <small className="text-secondary">
                {"Contacted On"}:{" "}
                {moment(note.contacted_at).format("ll")}
              </small>
            )}
            {note.follow_up_at && (
              <small className="text-secondary">
                {"Follow Up On"}:{" "}
                {moment(note.follow_up_at).format("ll")}
              </small>
            )}
            {!!note.risk_level && (
              <small className="text-secondary text-capitalize">
                Risk Level: {note.risk_level.label}
              </small>
            )}
          </div>
          <div className="d-flex flex-column align-items-end">
            {intersection(permissions, ["edit_everything"]).length > 0 &&
              note.author_id == current_user.id &&
              !isStaffApp && (
                <Button
                  size="sm"
                  variant={this.props.note.starred ? "warning" : "primary"}
                  onClick={() => {
                    this.handleStarChange();
                  }}
                >
                  {this.props.note.starred ? "Unstar" : "Star"}
                </Button>
              )}
            {intersection(permissions, ["edit_everything"]).length > 0 &&
              !isStaffApp && (
                <Button
                  size="sm"
                  variant="link"
                  onClick={() => {
                    this.setState({ action: "edit" });
                  }}
                >
                  Edit
                </Button>
              )}
          </div>
        </div>
      </div>
    );
  }

  simpleFormat(str) {
    if (str) {
      str = str.replace(/\r\n?/, "\n");
      str = $.trim(str);
      if (str.length > 0) {
        str = str.replace(/\n\n+/g, "</p><p>");
        str = str.replace(/\n/g, "<br />");
        str = "<p>" + str + "</p>";
      }
      return str;
    }
  }

  render() {
    return this.props.isStaffApp ? (
      <div
        className="border-bottom clickable p-4"
        onClick={() =>
          this.state.action !== "edit" && this.setState({ action: "edit" })
        }
      >
        {this.renderContent()}
      </div>
    ) : (
      <Card>
        <div
          className="card-block"
          style={{
            backgroundColor: this.props.note.starred ? "#FCF8E3" : "white",
          }}
        >
          {this.renderContent()}
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    current_user: state.current_user,
    organizationName: state.organization.name,
    residentId: state.resident.id,
    resident: state.resident,
    no_occupancies: !state.occupancies.length,
    permissions: state.permissions,
    isStaffApp: state.config.isStaffApp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNote: (note) => dispatch({ type: "UPDATE_NOTE", payload: { note } }),
    deleteNote: (note) => dispatch({ type: "DELETE_NOTE", payload: { note } }),
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(NoteComponent)
);
